import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const title = css`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing(3)};
`

export const editButton = css`
  display: inline-flex;
  align-items: center;
`
